export default function (arr, value, options) {
  if ($.inArray(value, arr) > -1) return options.fn(this);
  else return options.inverse(this);
}
